// extracted by mini-css-extract-plugin
export default {"Title":"Clients_Title__xyn4P","Pagination":"Clients_Pagination__EraYQ"};